import { QueryKey, useQueryClient } from '@tanstack/react-query';

type UseInvalidateQueryReturnType = {
  invalidateQuery: () => Promise<void>;
};

export const useInvalidateQuery = (
  queryKey: QueryKey
): UseInvalidateQueryReturnType => {
  const queryClient = useQueryClient();

  const invalidateQuery = () => queryClient.invalidateQueries({ queryKey });

  return { invalidateQuery };
};
